<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select Igloohome lock') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="calendar">{{ _('Available locks:') }}</label><br />
            <v-select :options="locks" v-model="lock" label="name" keys="['_id', 'name']" :placeholder="_('Type to search locks')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search locks') }}</template>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div style="height: 300px"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectLock"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'

export default {
  mixins: [constants],
  data () {
    return {
      lock: null,
      locks: []
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey'])
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectLock () {
      this.$emit('selectLock', this.lock)
    },
    async loadLocks() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/igloolocks.json?apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.locks = response.data.sort((a, b) => a.name > b.name ? 1 : -1)
    }
  },
  mounted () {
    this.loadLocks()
  }
}
</script>